// Imager.jsx
import React, { useContext, useEffect, useState } from "react";
import HabboImager from "../components/HabboImager";
import HybridProImager from "../components/HybridProImager";
import ContentBox from "../components/ContentBox";
import { FontScaleContext } from "../App";

const PRO_MIN_WIDTH = 940;
const MOBILE_MAX_WIDTH = 640;

const PUBLIC_IMAGER_CONFIG = {
    header: "Frankly Origins ProImager",
    icon: "/img/icons/icon_356.png",
    containerClassName: "select-none mt-2 min-w-[940px]",
    disableUpload: true,
    hiddenAssetCategories: ["Logos"],
    presets: [
        { name: "Standard", width: 650, height: 500 },
        { name: "Profile Banner", width: 332, height: 160 },
    ],
};

function Imager({ userData }) {
    const fontScale = useContext(FontScaleContext);
    const isLoggedIn = !!userData;

    const [usePro, setUsePro] = useState(isLoggedIn);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        if (!isLoggedIn) setUsePro(false);
        else setUsePro(true);
    }, [isLoggedIn]);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const isMobile = windowWidth < MOBILE_MAX_WIDTH;
    const isWideEnough = windowWidth >= PRO_MIN_WIDTH;
    const showNarrowNote = isLoggedIn && !isMobile && !isWideEnough;
    const showHybridPro = isLoggedIn && isWideEnough && usePro;

    return (
        <div style={{ zoom: 1 / fontScale }} className="w-full min-h-screen overflow-hidden">
            {/* Header bar */}
            <div className={`${showHybridPro ? "" : "max-w-6xl mx-auto"} px-4 pt-4 lg2:px-6 lg2:pt-6`}>
                {!isLoggedIn && (
                    <ContentBox className="mb-4">
                        <div className="w-full max-h-[120px] overflow-hidden rounded-lg border border-black/10 bg-black/5">
                            <div className="flex w-[1150px] gap-0 items-start">
                                <img src="/img/proimager_1.png" alt="" className="block w-1/3 h-auto shrink-0" style={{ transform: "translateY(-28%)" }} />
                                <img src="/img/proimager_3.png" alt="" className="block w-1/3 h-auto shrink-0" style={{ transform: "translateY(-20%)" }} />
                                <img src="/img/proimager_2.png" alt="" className="block w-1/3 h-auto shrink-0" style={{ transform: "translateY(-46%)" }} />
                            </div>
                        </div>
                        <div className="font-bold text-sm text-center mt-2">
                            Frankly members gain access to the ProImager! The ProImager allows you to create full scenes, with furni, any number of Habbos and even speech bubbles!
                        </div>
                    </ContentBox>
                )}

                <div className="flex items-center justify-end pb-2">
                    {!isLoggedIn ? (
                        <span className="font-['Jersey_10'] text-sm uppercase tracking-widest text-gray-400">
                            Login to use the Pro version of this imager.
                        </span>
                    ) : showNarrowNote ? (
                        <span className="font-['Jersey_10'] text-sm uppercase tracking-widest text-gray-400">
                            Your browser window is not wide enough to support the ProImager.
                        </span>
                    ) : isWideEnough ? (
                        <>
                        <span className="font-['Jersey_10'] text-lg uppercase tracking-widest mr-3 text-gray-400">
                            Switch Imager Mode:
                        </span>
                        <div
                            className="flex items-end gap-[3px] bg-coal_dark border-2 border-black p-[3px]"
                            style={{ boxShadow: "inset 0 2px 4px rgba(0,0,0,0.6)" }}
                        >
                            <button
                                type="button"
                                onClick={() => setUsePro(true)}
                                className={[
                                    "px-5 py-1.5 border border-black font-['Jersey_10'] uppercase tracking-widest text-sm transition-none",
                                    usePro
                                        ? "bg-gold text-coal translate-y-[3px]"
                                        : "bg-offwhite text-coal hover:bg-gold/40",
                                ].join(" ")}
                                style={{ boxShadow: usePro ? "inset 0 2px 0 rgba(0,0,0,0.4)" : "0 3px 0 0 #292929" }}
                            >
                                Pro
                            </button>
                            <button
                                type="button"
                                onClick={() => setUsePro(false)}
                                className={[
                                    "px-5 py-1.5 border border-black font-['Jersey_10'] uppercase tracking-widest text-sm transition-none",
                                    !usePro
                                        ? "bg-gold text-coal translate-y-[3px]"
                                        : "bg-offwhite text-coal hover:bg-gold/40",
                                ].join(" ")}
                                style={{ boxShadow: !usePro ? "inset 0 2px 0 rgba(0,0,0,0.4)" : "0 3px 0 0 #292929" }}
                            >
                                Basic
                            </button>
                        </div>
                        </>
                    ) : null}
                </div>
            </div>

            {/* Imager content */}
            {showHybridPro ? (
                <HybridProImager userData={userData} config={PUBLIC_IMAGER_CONFIG} />
            ) : (
                <div className="max-w-6xl mx-auto px-4 lg2:px-6 pb-6">
                    <HabboImager icon="/img/icons/icon_356.png" />
                </div>
            )}
        </div>
    );
}

export default Imager;
